import React from 'react';
import './FormComponents.scss';

const DateTimeInput = ({
  id,
  name,
  label,
  value,
  onChange,
  required = false,
  disabled = false,
  className = '',
  min = '',
  max = '',
  ...props
}) => {
  return (
    <div className={`form-group ${className}`}>
      {label && (
        <label htmlFor={id} className="form-label">
          {label}
          {required && <span className="required-asterisk">*</span>}
        </label>
      )}
      <input
        type="datetime-local"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        className="form-input datetime-input"
        required={required}
        disabled={disabled}
        min={min}
        max={max}
        {...props}
      />
    </div>
  );
};

export default DateTimeInput;